import React, { useState } from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import TrashIcon from 'assets/images/16px/bin@1x.svg'
import EditIcon from 'assets/images/16px/edit@1x.svg'
import PropTypes from 'prop-types'
import HistoryIcon from '@material-ui/icons/History'
import urlConstructor from 'utils/urlConstructor'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import PlayerStatusToggle from 'containers/PausePlayer'
import EditDialog from './EditDialog'
import MovePlayer from './MovePlayer'
import RemovePlayerDialog from './RemovePlayerDialog'
import { TEAM_PLAYER_TRANSFER_HISTORY_ROUTE } from 'constants/routes'

const GridActionsCell = ({
  row: { player, uuid, onUpdate, onDelete, showTransferOption },
  history,
  match: {
    params: { teamUuid, seasonId },
  },
}) => {
  const [deleteIsOpen, setDeleteIsOpen] = useState(false)
  const [editIsOpen, setEditIsOpen] = useState(false)

  const handleDeleteClick = () => {
    setDeleteIsOpen(true)
  }

  const handleDeleteClose = () => {
    setDeleteIsOpen(false)
  }

  const handleDeleteConfirm = () => {
    setDeleteIsOpen(false)
    onDelete(uuid)
  }

  const handleEditClick = () => {
    setEditIsOpen(true)
  }

  const handleEditClose = () => {
    setEditIsOpen(false)
  }

  const handlePlayerTransferHistoryIconClick = () => {
    history.push(
      urlConstructor(
        teamUuid,
        seasonId,
        TEAM_PLAYER_TRANSFER_HISTORY_ROUTE.populateURLParams({
          playerId: uuid,
        })
      )
    )
  }

  return (
    <>
      {deleteIsOpen && (
        <RemovePlayerDialog
          open={deleteIsOpen}
          onClose={handleDeleteClose}
          onSubmit={handleDeleteConfirm}
        />
      )}
      {editIsOpen && (
        <EditDialog
          open={editIsOpen}
          onClose={handleEditClose}
          player={player}
          updatePlayer={onUpdate}
        />
      )}

      <Tooltip title={<Translate id="button.edit" />} placement="top" arrow>
        <IconButton onClick={handleEditClick}>
          <img src={EditIcon} alt="" />
        </IconButton>
      </Tooltip>

      <Tooltip title={<Translate id="button.remove" />} placement="top" arrow>
        <IconButton onClick={handleDeleteClick}>
          <img src={TrashIcon} alt="" />
        </IconButton>
      </Tooltip>

      <MovePlayer playerUuid={uuid} withTransfer={showTransferOption} />
      {showTransferOption && (
        <Tooltip
          title={<Translate id="button.transfer-history" />}
          placement="top"
          arrow
        >
          <IconButton onClick={handlePlayerTransferHistoryIconClick}>
            <HistoryIcon
              fontSize="small"
              color="disabled"
              style={{ fontSize: '1.2rem' }}
            />
          </IconButton>
        </Tooltip>
      )}

      <PlayerStatusToggle player={player} key={uuid} />
    </>
  )
}

GridActionsCell.propTypes = {
  row: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    player: PropTypes.shape({}),
    showTransferOption: PropTypes.bool,
  }).isRequired,
  history: PropTypes.shape().isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      seasonId: PropTypes.string.isRequired,
      teamUuid: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

export default withRouter(GridActionsCell)
